import {Injector, Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Query} from '../../models/query/query';
import {Orn} from '../../models/lookups/orn';
import {AppModulePath} from '../../models/app-module-path';
import {WebMethodResult} from '../../models/web-method-result';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class OrnService extends BaseService {

  private listUrl = '/api/orn/list';
  private saveUrl = '/api/orn/save';
  private deleteUrl = '/api/orn/delete/';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Orn[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Orn[]>(url, AppModulePath.ORN).pipe(
      map(res => res.map(obj => new Orn(obj))),
      catchError(this.handleError));
  }

  save(orn: Orn): Observable<Orn> {
    return this.post<Orn>(this.saveUrl, AppModulePath.ORN, orn).pipe(
      map(res => new Orn(res)),
      catchError(this.handleError));
  }

  delete(id: number): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.ORN).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

}
